import React, { useState } from "react";
import ISO3166 from "iso-3166-1";
import { TeamOutlined, FieldTimeOutlined   } from "@ant-design/icons";
import { 
	Row,
	Col,
	message, 
	Select,
	Form,
	Descriptions, 
	Typography,
	Input,
	Radio,
} from "antd";
import PropTypes from "prop-types";
import { get_company_by_nit_for_entity } from "../../../../services";

const { Search } = Input;
const { Title } = Typography;

const noClient = {
	id: undefined,
	type: undefined,
	tid:  undefined,
	name: undefined,
	address: undefined,
};

export const SelectClient = ({token, company, form, handleFieldChange, clients = [], isRecurrency = false}) => {
	const [ searchClient, setSearchClient] = useState(false);
	const [ selectedClientForm, setSelectedClientForm] = useState("search");
	const [ selectedClient, setSelectedClient] = useState(noClient);

	// Effect to reset selectedClient when clients changes
	React.useEffect(() => {
		setSelectedClient(noClient);
		handleFieldChange("client", "client", noClient);
	}, [company.id]);

	const handleSelectClient = (value) => {
		const foundClient = clients.find(client=> client.id == value);

		const newClient = {
			... selectedClient,
			tid: foundClient.entity_company_tid,
			name: foundClient.name,
			address: foundClient.address,
			id: value,
			type: "client"
		};

		setSelectedClient(newClient);
		handleFieldChange("client", "client", newClient);
	};

	const handelSelectClientForm = (value) => {
		setSelectedClientForm(value);
		setSelectedClient(noClient);
		handleFieldChange("client", "client", noClient);
	};

	const handleSelectClientType = (value) => {
		let newClient = {
			... selectedClient,
			type: value
		};

		if (value === "foreign") {
			newClient.name = "";
			newClient.address = "";
			newClient.tid = "";
			newClient.country = null;
		} else if (selectedClient.tid && selectedClient.tid.toLowerCase() == "cf") {
			newClient.name = "";
			newClient.address = "";
			newClient.id = "temporal";
			newClient.tid = "CF";
			newClient.country = null;
		} else {
			newClient.country = null;
		}

		setSelectedClient(newClient);
		handleFieldChange("client", "client", newClient);
	};

	const handleSearchClient = async (value) => {
		if(value.trim() === ""){
			message.error("Porfavor ingresa un NIT");
			return;
		}
		
		if (selectedClient.type && value.toLowerCase() !== "cf") {
			setSearchClient(true);
			// setInsertClientDataManualy(false);
			const res = await get_company_by_nit_for_entity(token, value, selectedClient.type);
			if (res) {
				if (Object.keys(res).length === 0 && res.constructor === Object) {
					message.error("No encontrado");
				}
				const newClient = {
					... selectedClient,
					tid: value,
					name: res.name,
					address: res.address,
					id: "temporal"
				};
				setSelectedClient(newClient);
				handleFieldChange("client", "client", newClient);
				setSearchClient(false);
			}
		}
		else {
			message.error("Debe seleccionar un tipo de cliente");
		}
	};

	const handleChangeSearchClient = (value) => {
		const isCFAndCompany = value.toLowerCase() === "cf";
		const isCompanyOrPerson = ["company", "person"].includes(selectedClient.type);
		const isForeign = selectedClient.type === "foreign";
    
		const createNewClient = (tid) => ({
			...selectedClient,
			tid,
			name: "",
			address: "",
			id: "temporal"
		});
    
		if (isCFAndCompany) {
			const newClient = createNewClient("CF");
			setSelectedClient(newClient);
			handleFieldChange("client", "client", newClient);			
		} else if (isCompanyOrPerson || isForeign) {
			const newClient = createNewClient(value);
			setSelectedClient(newClient);
			handleFieldChange("client", "client", newClient);
		}
	};

	return (
		<Row >
			<Col span={24} > 
				<Title level={5} style={{ margin: "0", padding: "0" }}>Cliente</Title>
				<Row gutter={[10,0]}>
					{
						selectedClientForm === "search" &&
							<Col span={18}>
								<Form.Item
									name={["client", "id"]}
									rules={[{ required: true, message: "Por favor ingrese un Cliente" }]}
								>
									<Select
										showSearch
										style={{ width: "100%" }}
										placeholder="Selecciona un Cliente"
										optionFilterProp="label"
										onChange={handleSelectClient}
										filterOption={(input, option) =>
											(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
										}
										value={selectedClient.id}
										options={
											clients.map(client => ({
												label: `${client.name} (${client.entity_company_tid})`,
												value: client.id,
											}))
										}
										disabled={isRecurrency}
									/>
								</Form.Item>
							</Col>
					}
					{
						selectedClientForm === "temporal" &&
							<>
								<Col span={18}>
									<Form.Item
										name={["client","tid"]}
										rules={[{ required: true, message: "Por favor ingrese un Cliente" }]}
									>
										<Search
											disabled={isRecurrency || selectedClient?.type === "foreign"}											
											placeholder='NIT'
											enterButton
											loading={
												searchClient
											}
											onSearch={
												(e) => {
													form.getFieldValue("clientType") !== "foreign"?
														handleSearchClient(e) : "";
												}
											}
											onChange={(e) => handleChangeSearchClient(e.target.value)}
											addonBefore={
												<Form.Item
													style={{margin:"0"}}
													name={["client","type"]}
													rules={[{ required: true, message: "Por favor ingrese un tipo de NIT" }]}
												>
													<Select
														style={{ width: 110 }}
														placeholder='Tipo'
														onChange={handleSelectClientType}														
														options={[
															{
																label: "NIT",
																value: "company"
															},
															{
																label: "CUI",
																value: "person"
															},
															{
																label: "Extranjero",
																value: "foreign"
															},
														]}
													/>
												</Form.Item>
											}
										/>
									</Form.Item>
								</Col>
							</>
					}
					<Col span={6}>
						<Radio.Group
							style={{width:"100%"}}
							value={selectedClientForm}
							onChange={(e) => handelSelectClientForm(e.target.value)}
						>
							<Radio.Button style={{width:"50%"}} value="search"><TeamOutlined /></Radio.Button>
							<Radio.Button style={{width:"50%"}} value="temporal"><FieldTimeOutlined /></Radio.Button>
						</Radio.Group>  
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<Descriptions
					layout="horizontal" 
					size="small" 
					column={1}
					style={{
						marginLeft:"30px"
					}}

				>					
					{selectedClientForm === "search" && <Descriptions.Item label='NIT' style={{ width: "100%" }}>
						<Form.Item
							style={{margin:"0", width:"100%"}}
							name={["client","tid"]}
							rules={[{ required: true, message: "Por favor ingrese un NIT" }]}
						>
							<Input disabled={true} style={{ width: "100%" }}></Input>
						</Form.Item>
					</Descriptions.Item>}

					{selectedClientForm !== "search" && <Descriptions.Item label='Nombre' style={{ width: "100%" }}>
						<Form.Item
							style={{margin:"0", width:"100%"}}
							name={["client","name"]}
							rules={[{ required: true, message: "Por favor ingrese un nombre" }]}
						>														
							<Input disabled={selectedClient?.type !== "foreign" && selectedClient?.tid?.toLowerCase() !== "cf"} style={{ width: "100%" }}></Input>
						</Form.Item>
					</Descriptions.Item>}

					{selectedClient?.type === "foreign" && <Row gutter={16}>						
						<Col span={8}>
							<Form.Item 
								label="NIT" 
								name={["client", "tid"]} 
								style={{ margin: "0" }}
								rules={[{ required: selectedClient?.type === "foreign", message: "Por favor ingrese un NIT" }]}
							>
								<Input style={{ width: "100%" }} />
							</Form.Item>
						</Col>
						<Col span={16}>
							<Form.Item 
								label="País" 
								name={["client", "country"]} 
								style={{ margin: "0", marginLeft: "10px" }}
							>
								<Select
									allowClear
									placeholder="Selecciona un país"
									style={{ width: "100%" }}
									options={ISO3166.all().map((country) => ({
										value: country.alpha2,
										label: country.country,
									}))}
								/>
							</Form.Item>
						</Col>
					</Row>}
										
					<Descriptions.Item label='Dirección' style={{ width: "100%" }}>
						<Form.Item
							style={{margin:"0", width:"100%"}}
							name={["client","address"]}
							rules={[{ required: true, message: "Por favor ingrese una dirección" }]}
						>
							<Input disabled={isRecurrency} style={{ width: "100%" }}></Input>
						</Form.Item>
						<Form.Item
							style={{margin:"0"}}
							name={["client","id"]}
						/>
						<Form.Item
							style={{margin:"0"}}
							name={["client","name"]}
						/>
					</Descriptions.Item>
				</Descriptions>
			</Col>
			<Col span={6}></Col>
		</Row>
	);
};

SelectClient.propTypes =  {	
	company: PropTypes.shape({
		accounting_resources: PropTypes.shape({
			accounting_plan: PropTypes.arrayOf(PropTypes.shape({
				id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
				display_name: PropTypes.string.isRequired,
			})).isRequired,
			sale_accounts: PropTypes.arrayOf(
				PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
			).isRequired,
		}).isRequired,
		id: PropTypes.string,
	}).isRequired,
	handleFieldChange: PropTypes.func.isRequired,
	form: PropTypes.any.isRequired,
	clients: PropTypes.array,
	token: PropTypes.string.isRequired,
	isRecurrency: PropTypes.bool
};